import React from "react";
import { IPage } from "../../../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import Table from "../../../../shared/table";
import moment from "moment";
import { ICompanyUsers } from "../../../../interfaces/company-user/ICompanyUsers";

const tableColumns = [
  "Name",
  "Email",
  "Role",
  "Phone Number",
];

interface ICompanyUsersTable {
  rows: ICompanyUsers[];
  paginationData?: IPage;
  rowsLoading: boolean;
  setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const CompanyUsersTable = ({
  rows,
  paginationData,
  rowsLoading,
  setPaginationState,
}: ICompanyUsersTable) => {
  return (
    <Table
      columns={tableColumns}
      paginationData={paginationData}
      setPaginationState={setPaginationState}
    >
      {rowsLoading ? (
        <>
          {[...Array(4)].map((x, i) => {
            return (
              <tr key={i}>
                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                  return (
                    <td key={j} className="td-1 !min-w-[100%] text-center py-5">
                      <span></span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </>
      ) : (
        <>
          {rows?.length > 0 &&
            rows?.map((row, idx: number) => {
              return (
                <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-6 py-4">{row?.name}</td>
                  <td className="px-6 py-4">{row.email}</td>
                  <td className="px-6 py-4">{row.role}</td>
                  <td className="px-6 py-4">{row.phone}</td>
                </tr>
              );
            })}
        </>
      )}
    </Table>
  );
};

export default CompanyUsersTable;
